export default "__VITE_ASSET__65532918__"